import React, { useEffect, useRef, useState } from 'react';
import * as R from 'ramda';
import {  useSelector } from 'react-redux';
import { Profile } from './../../../../_common/profile';
import parsePhoneNumber from 'libphonenumber-js';

export const SettingsSecurite = () => {
    const securityForm = useRef(null);
    const user = useSelector(state => state.user);
    const [wasValidated, setWasValidated] = useState(false);
    const [passwordRequirements, setPasswordRequirements] = useState({ hasLower: false, hasUpper: false, hasDigits: false });

    let initState = {
        email: '',
        password: '',
        confirmPassword: '',
        phoneNumber: '',
        otpCode: '',
        countryCode: '33',
        phoneCountry: 'FR'
    }

    if(!R.isNil(user.user.phoneNumber) && !R.isEmpty(user.user.phoneNumber)){
        const phone = parsePhoneNumber(user.user.phoneNumber);
        if(phone.isValid()){
            initState.phoneNumber = phone.nationalNumber;
            initState.countryCode = phone.countryCallingCode;
            initState.phoneCountry = phone.country;
        }
    }

    if(!R.isEmpty(user.user.email)){
        initState.email = user.user.email;
    }
    const [credentials, setCredentials] = useState(initState);
    return (
    <Profile passwordRequirements={passwordRequirements} setPasswordRequirements={setPasswordRequirements} registerPage={false}
        credentials={credentials} setCredentials={setCredentials} credentialsForm={securityForm} wasValidated={wasValidated} setWasValidated={setWasValidated} isSettings={true} />
    )
};